module.exports = __webpack_public_path__ + "static/logo-dcp-8fea38025f293d92983495aff45f412f.png";